import React from 'react'
import { Route, Routes } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
// Display
import DisplayPage from '../app/display/pages/DisplayPage'
import DisplayDashboardPage from '../app/display/pages/DisplayDashboardPage'



function DisplayRoutes() {
  return (
    <Routes>
        {/* Display */}
        <Route path="/display/dashboard" element={<DisplayDashboardPage /> }></Route>
        <Route path="/display/tv/:displayType" element={<DisplayPage /> }></Route>    
    </Routes>
  )
}

export default DisplayRoutes